import { array, object, string } from "yup"
import addressModel from "./atoms/address.model"
import { email, firstName, lastName, phoneNumber } from "./yup.common"

export default object({
  firstName: firstName.required("Please enter first name!"),
  lastName: lastName.required("Please enter the last name!"),
  number: phoneNumber.required("Please enter the mobile number!"),
  username: string()
    .required("Please enter a valid username")
    .label("Username"),
  email,
  address: addressModel.required("Please enter a valid address!"),
  groups: array()
    .min(1, "Please select atleast 1 group for the vendor!")
    .required("Please select atleast 1 group for the vendor!"),
})
